module.exports = __webpack_public_path__ + "img/hydt_item.161eb0a1.png";